export default {
      id: "qr-android-usage",
      viewBox: "0 0 1024 1024",
      url: "/" + "images/icons.3.109.2.svg#qr-android-usage",
      toString: function () {
        return this.url;
      }
    }